import React, { useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Grid } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
// import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
// import UploadIcon from "@mui/icons-material/Upload";
import Zoom from "react-medium-image-zoom";
// import CreateIcon from "@mui/icons-material/Create";
// import DeleteIcon from "@mui/icons-material/Delete";
// import StarIcon from "@mui/icons-material/Star";
// import StarBorderIcon from "@mui/icons-material/StarBorder";
import EditIcon from "@mui/icons-material/Edit";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import {
  makeGetRequest,
  makePostRequest,
  uploadFileRequest,
} from "../../../utils/utils";
import swal from "sweetalert";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DoneIcon from "@mui/icons-material/Done";


// import ServiceProViderAddModal from "./ServiceProViderAddModal";
// import AddVehicleModal from "./AddVehicleModal";
// End

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function UserProfileDtlsTab() {
  const navigate = useNavigate();

  const addCommitee = () => {
    var element = document.getElementById("successfullAdd");
    element.classList.toggle("hideModal");
  };

  // For Modal
  const [open3, setOpen3] = React.useState(false);
  const [scroll3, setScroll3] = React.useState("paper");

  const handleClickOpen3 = (scrollType) => () => {
    setOpen3(true);
    setScroll3(scrollType);
    setEditUser(true);
  };

  const handleClose3 = () => {
    setOpen3(false);
  };

  // const descriptionElementRef3 = React.useRef(null);
  React.useEffect(() => {
    if (open3) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open3]);
  // End

  // For Modal
  const [open4, setOpen4] = React.useState(false);
  const [scroll4, setScroll4] = React.useState("paper");

  const handleClickOpen4 = (scrollType) => () => {
    setOpen4(true);
    setScroll4(scrollType);
  };

  const handleClose4 = () => {
    setOpen4(false);
  };

  // End

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");

  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  const [pdfImage] = React.useState(
    require("../../../assets/Images/pdf.png")
  );
  const [txtImage] = React.useState(
    require("../../../assets/Images/text.png")
  );

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  // End

  // For Modal 2
  const [open2, setOpen2] = React.useState(false);
  const [scroll2] = React.useState("paper");

  // const handleClickOpen2 = (scrollType) => () => {
  //   setOpen2(true);
  //   setScroll2(scrollType);
  // };

  const handleClose2 = () => {
    setOpen2(false);
  };
  const descriptionElementRef2 = React.useRef(null);

  const [userName, setUserName] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");

  const [contact, setContactNo] = React.useState("");
  const [email, setEmailId] = React.useState("");
  // const [password, setPassword] = React.useState("");
  const [documentsList, setDocumentsList] = React.useState([]);

  const [societyName, setSocietyName] = React.useState("");
  const [societyAddress, setSocietyAddress] = React.useState("");
  const [, setSocietyContact] = React.useState("");
  const [, setSocietyEmailId] = React.useState("");
  const [societyDocumentsList, setSocietyDocumentsList] = React.useState([]);
  const [isEditSociety, setEditSociety] = React.useState(false);
  const [isEditUser, setEditUser] = React.useState(false);

  const [buildingCount, setBuildingCount] = React.useState("");
  const [Upload, setUpload] = React.useState(false);

  async function GetSocietyById(societyId) {
    var societyObj = "";
    var bodyFormData = "";
    await makeGetRequest("society/getbyid/" + societyId, bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          societyObj = response.data.data;
          console.log("IN Get Society");
          console.log(societyObj);

          setSocietyName(societyObj.society_name);
          setSocietyAddress(societyObj.address);
          setBuildingCount(societyObj.building_count);
          setSocietyContact(societyObj.contact);
          setSocietyEmailId(societyObj.email_id);
          if (response.data.data.document_list != null) {
            setSocietyDocumentsList(societyObj.document_list);
          }
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
    return societyObj;
  }

  // async function editResident(residentId) {
  //   navigate("/EditResident/" + residentId);
  // }

  //Validations For Resident Details
  const Validation_Schema = Yup.object().shape({
    firstName: Yup.string()
      .required("Required")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Numbers not allowed!!"
      ),
    lastName: Yup.string()
      .required("Required")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Numbers not allowed!!"
      ),
    contact: Yup.string()
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "Phone number is not valid"
      )
      .min(10, "phone no must be greater than or equal to 10 digits")
      .max(15, "phone no must be greater than or equal to 10-15 digits")
      .required("Required"),
    email: Yup.string().email("Invalid email").required("Required"),
    // age: Yup.string()
    //   .matches(/^\d+$/, "The field should have digits only")
    //   .min(1, "Invalid Age ")
    //   .max(3, "Invalid Age")
    //   .required("Required"),
  });

  var formikInitials = {
    firstName: firstName,
    lastName: lastName,
    contact: contact,
    email: email,

    // age: age,
  };

  // function validateImageOrFile(fileData) {
  //   if (fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
  //     return true;
  //   else return false;
  // }

  async function uploadImageOrFile(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;

    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
      }
    );
    return fileUrl;
  }

  async function uploadDocuments(e, userType) {
    // handle validations
    const file = e.target.files[0];
    console.log("Document", file);
    var profilePicUrl = await uploadImageOrFile(file);
    console.log("Doc", profilePicUrl);
    documentsList.push(profilePicUrl);
    setDocumentsList(documentsList);

    swal("Success", "Document Uploaded successfully", "success", {
      timer: 1000,
      buttons: false,
    });

    setUpload(!Upload);
  }

  async function deleteDocument(userType, index) {
    documentsList.splice(index, 1); // 2nd parameter means remove one item only
    setDocumentsList(documentsList);
    swal("Success", "Document deleted successfully", "success", {
      timer: 1000,
      buttons: false,
    });
    setUpload(!Upload);
  }

  async function editUser() {
    let inputdata = {
      resident_id: localStorage.getItem("userId"),
      user_obj: {
        first_name: firstName,
        last_name: lastName,
        // age: age,
        contact_no: contact,
        email_id: email,
        // profile_pic: profile_pic,
      },
      document_list: documentsList,
      // password: password,
    };
    console.log(inputdata);
    makePostRequest("resident/update", inputdata)
      .then((response) => {
        // checked codition if responce is empty
        if (response.data.data !== undefined) {
          swal("Success", "User updated successfully", "success", {
            timer: 1000,
            buttons: false,
          });

          var userName = firstName + " " + lastName;

          localStorage.setItem("userName", userName);
          setEditUser(false);
          window.location.reload();

          // navigate('/ResidentManagement')
          // a11yProps(1);
        } else {
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const isEditUserRef = useRef(isEditUser);
  isEditUserRef.current = isEditUser;

  React.useEffect(() => {
    if (open2) {
      const { current: descriptionElement } = descriptionElementRef2;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

    let userId = localStorage.getItem("userId");

    if (!isEditUserRef.current) {
      makeGetRequest("resident/getbyid/" + userId)
        .then((response) => {
          if (response.status === 201) {
            let userObj = response.data.data.user_obj;
            setUserName(userObj.first_name + " " + userObj.last_name);
            setFirstName(userObj.first_name);
            setLastName(userObj.last_name);
            setContactNo(userObj.contact_no);
            setEmailId(userObj.email_id);
            if (response.data.data.document_list != null) {
              setDocumentsList(response.data.data.document_list);
            }

            GetSocietyById(localStorage.getItem("socityid"));
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
    }
  }, [open2, Upload]);
  // End

  return (
    <>
      <div>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="scrollable auto tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab
                label="Personal Info"
                {...a11yProps(0)}
                onClick={() => setEditSociety(false)}
              />
              <Tab
                label="Society Details"
                {...a11yProps(1)}
                onClick={() => setEditSociety(true)}
              />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <Grid container spacing={3} style={{ marginTop: "10px" }}>
              <Grid item xs={12} md={8}>
                <div className="tabViewOfProvider tabViewOfProviderUsr">
                  <ul>
                    <li>
                      <span>Name</span> <b>{userName}</b>
                    </li>
                    <li>
                      <span>Phone Number</span> <b>{contact}</b>
                    </li>
                    <li>
                      <span>Email Id</span> <b>{email}</b>
                    </li>
                    <li>
                      {/* <span>Occupation </span> */}
                      {/* {userProfile.user_obj.occupation? */}
                      {/* <b>{userProfile.user_obj.occupation}</b> */}
                      {/* :<b>-</b>} */}
                    </li>
                  </ul>
                </div>
              </Grid>

              <Grid item xs={12} md={4}>
                <div className="tabViewOfProviderRight">
                  <h4 className="doquProviderHed">Documents</h4>

                  {documentsList ? (
                    <>
                      {documentsList.map((option) => (
                        <div className="doquOut">
                          <div className="doquView1">
                            <Zoom>
                              <div className="doquView">
                                {option.split(".").pop() === "txt" ? (
                                  <img src={txtImage} alt="altimg" />
                                ) : option.split(".").pop() === "pdf" ? (
                                  <img src={pdfImage} alt="altimg" />
                                ) : (
                                  <img src={option} alt="altimg" />
                                )}
                              </div>
                            </Zoom>
                            <span>
                              <a href={option}>{option.split("/").pop()} </a>
                            </span>
                          </div>
                          {/* <div className="doquView2">
                      <div className="downLoDoqBt">
                        <UploadIcon />
                        <input type="file" />
                      </div>
                      <span>Document One</span>
                    </div> */}
                        </div>
                      ))}
                    </>
                  ) : (
                    <div>
                      <span>No Documents Uploaded..</span>
                    </div>
                  )}
                </div>
              </Grid>

              <Grid item xs={12} md={12} style={{ textAlign: "center" }}>
                <Button
                  className="addApBt addWingNewt"
                  onClick={handleClickOpen3("body")}
                >
                  <EditIcon /> &nbsp; Edit Personal Info
                </Button>
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Grid container spacing={3} style={{ marginTop: "10px" }}>
              <Grid item xs={12} md={8}>
                <div className="tabViewOfProvider tabViewOfProviderUsr">
                  <ul>
                    <li>
                      <span>Name</span> <b>{societyName}</b>
                    </li>
                    <li>
                      <span>Address</span> <b>{societyAddress}</b>
                    </li>
                    <li>
                      <span>Phone Number</span> <b>{contact}</b>
                    </li>
                    <li>
                      <span>Email Id</span> <b>{email}</b>
                    </li>
                    <li>
                      <span>Buildings </span> <b>{buildingCount}</b>
                    </li>
                  </ul>
                </div>
              </Grid>

              <Grid item xs={12} md={4}>
                <div className="tabViewOfProviderRight">
                  <h4 className="doquProviderHed">Documents</h4>

                  {societyDocumentsList ? (
                    <>
                      {societyDocumentsList.map((option) => (
                        <div className="doquOut">
                          <div className="doquView1">
                            <Zoom>
                              <div className="doquView">
                                {option.split(".").pop() === "txt" ? (
                                  <img src={txtImage} alt="altimg" />
                                ) : option.split(".").pop() === "pdf" ? (
                                  <img src={pdfImage} alt="altimg" />
                                ) : (
                                  <img src={option} alt="altimg" />
                                )}
                              </div>
                            </Zoom>
                            <span>
                              <a href={option}>{option.split("/").pop()} </a>
                            </span>
                          </div>
                          {/* <div className="doquView2">
                      <div className="downLoDoqBt">
                        <UploadIcon />
                        <input type="file" />
                      </div>
                      <span>Document One</span>
                    </div> */}
                        </div>
                      ))}
                    </>
                  ) : (
                    <div>
                      <span>No Documents Uploaded..</span>
                    </div>
                  )}
                </div>
              </Grid>

              <Grid item xs={12} md={12} style={{ textAlign: "center" }}>
                {isEditSociety ? (
                  <Button
                    className="addApBt addWingNewt"
                    onClick={() => navigate("/BuildingYes")}
                  >
                    <EditIcon /> &nbsp; Edit Society Details
                  </Button>
                ) : (
                  <Button
                    className="addApBt addWingNewt"
                    onClick={handleClickOpen4("body")}
                  // onClick={() => editResident(localStorage.getItem('userId'))}
                  >
                    <EditIcon /> &nbsp; Edit Personal Info
                  </Button>
                )}
              </Grid>
            </Grid>
          </TabPanel>
        </Box>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Apartment</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              {/* <ServiceProViderAddModal /> */}
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* Secound Modal */}
      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll2}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Vehicle</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll2 === "paper"}>
            <div className="modalInnerCont">{/* <AddVehicleModal /> */}</div>
          </DialogContent>
        </Dialog>
      </div>

      {/* Edit User 1 */}
      <div className="modalMain">
        <Dialog
          open={open3}
          // onClose={handleClose3}
          scroll={scroll3}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Edit Personal Info</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose3} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Formik
                  enableReinitialize
                  initialValues={formikInitials}
                  validationSchema={Validation_Schema}
                  onSubmit={editUser}
                >
                  {({
                    values,
                    handleChange,
                    errors,
                    setFieldTouched,
                    touched,
                    isValid,
                    handleSubmit,
                  }) => (
                    <Form>
                      <Grid container spacing={3} className="addCommitee1">
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">First Name</label>
                          <input
                            className="inputSt"
                            placeholder="First Name"
                            value={values.firstName}
                            onChange={handleChange("firstName")}
                            onBlur={() => setFieldTouched("firstName")}
                            onChangeCapture={(e) =>
                              setFirstName(e.target.value)
                            }
                          />
                          {errors.firstName && touched.firstName ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.firstName}
                            </div>
                          ) : null}
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Last Name</label>
                          <input
                            className="inputSt"
                            placeholder="Last Name"
                            value={values.lastName}
                            onChange={handleChange("lastName")}
                            onBlur={() => setFieldTouched("lastName")}
                            onChangeCapture={(e) => setLastName(e.target.value)}
                          />
                          {errors.lastName && touched.lastName ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.lastName}
                            </div>
                          ) : null}
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Phone Number</label>
                          <input
                            className="inputSt"
                            placeholder="Phone Number"
                            value={values.contact}
                            onChange={handleChange("contact")}
                            onBlur={() => setFieldTouched("contact")}
                            onChangeCapture={(e) =>
                              setContactNo(e.target.value)
                            }
                          />
                          {errors.contact && touched.contact ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.contact}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Email id</label>
                          <input
                            className="inputSt"
                            placeholder="Email Id"
                            value={values.email}
                            onChange={handleChange("email")}
                            onBlur={() => setFieldTouched("email")}
                            onChangeCapture={(e) => setEmailId(e.target.value)}
                          />
                          {errors.email && touched.email ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.email}
                            </div>
                          ) : null}
                        </Grid>
                        {/* <Grid item xs={12} md={6}>
                    <label className="tabsLabel">Occupation</label>
                    <input className="modalInputStSelect" />
                  </Grid> */}
                        <Grid item xs={12} md={12}>
                          <div className="tabRightDiv">
                            <h4 className="documeUpload documeUploadIcon">
                              Upload Documents
                              <Button className="forUploadOnly">
                                <FileUploadIcon />
                                <input
                                  type="file"
                                  style={{
                                    opacity: 0,
                                    position: "absolute",
                                    left: 0,
                                  }}
                                  id="documentsList"
                                  value={values.documentsList}
                                  onChange={(event) =>
                                    uploadDocuments(event, "resident")
                                  }
                                  onChangeCapture={() =>
                                    setDocumentsList(documentsList)
                                  }
                                />
                              </Button>
                            </h4>
                            {/* {(documentsList)?
                        <> */}
                            {documentsList.map((option, index) => (
                              <div id="documentDiv" className="doqumentDiv1">
                                <span>
                                  {option.split("/").pop().replace("%20", " ")}
                                  <DoneIcon className="doneIcon" />{" "}
                                </span>

                                <Button
                                  className="documRemove"
                                  onClick={() =>
                                    deleteDocument("resident", index)
                                  }
                                >
                                  <DeleteForeverIcon className="deleIco" />
                                </Button>
                              </div>
                            ))}
                            {/* </>
                        :<>No Documents Uploaded</>} */}
                          </div>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <div className="modalMainBtMain cancelBtForAllOuter">
                            <Button className="modalMainBt cancelBtForAll">
                              Cancel
                            </Button>
                            <Button
                              className="modalMainBt"
                              onClick={() => editUser()}
                            >
                              Update
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" alt="altimg" />
                      <h4>Success !</h4>
                      <p>
                        Changes added <br />
                        successfully in database
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* Edit User 2 */}
      <div className="modalMain">
        <Dialog
          open={open4}
          // onClose={handleClose4}
          scroll={scroll4}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Edit Society Details</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose4} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={6}>
                    <label className="tabsLabel">Name</label>
                    <input className="modalInputStSelect" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label className="tabsLabel">Address</label>
                    <input className="modalInputStSelect" />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <label className="tabsLabel">Buildings Count</label>
                    <input className="modalInputStSelect" />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <label className="tabsLabel">Wings Count</label>
                    <input className="modalInputStSelect" />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <label className="tabsLabel">Total Apartments</label>
                    <input className="modalInputStSelect" />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <div className="tabRightDiv">
                      <h4 className="documeUpload">Documents Upload</h4>
                      <div className="doqumentDiv1">
                        <span>Company Adhaar Card</span>
                        <FileUploadIcon />
                        <input type="file" />
                        <CloseIcon className="deletUploaded" />
                      </div>
                      <div className="doqumentDiv1">
                        <span>Document 1</span>
                        <FileUploadIcon />
                        <input type="file" />
                        <CloseIcon className="deletUploaded" />
                      </div>
                      <div className="doqumentDiv1">
                        <span>Document 2</span>
                        <FileUploadIcon />
                        <input type="file" />
                        <CloseIcon className="deletUploaded" />
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button className="modalMainBt" onClick={addCommitee}>
                        Save
                      </Button>
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" alt="altimg" />
                      <h4>Success !</h4>
                      <p>
                        Changes added <br />
                        successfully in database
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default UserProfileDtlsTab;
